import React from 'react';
import { Link } from 'react-router-dom';
import {
  Button,
  Col,
} from 'reactstrap';
import { useIntl } from 'react-intl';

const EmptySyncedCollections = () => {
  const intl = useIntl();

  return (
    <div className="empty-state-wrapper row align-items-center justify-content-center">
      <Col lg="5" xs="12">
        <h2>{intl.formatMessage({ defaultMessage: 'Sync Collections to access them from your desktop' })}</h2>
        <div className="mt-4">
          {intl.formatMessage({ defaultMessage: 'Keep track of all your synced Collections, in one place.' })}
        </div>
        <Button tag={Link} to="/collections" color="primary" className="mt-4">
          {intl.formatMessage({ defaultMessage: 'Sync a Collection' })}
        </Button>
      </Col>
    </div>
  );
};

export default EmptySyncedCollections;
